const hotSandwiches = [
    {
        item: "Carnitas Torta",
        ingredients: "baguette, carnitas, mayo, mustard, avocado, avocado, salsa"
    },
    {
        item: "The Cuban",
        ingredients: "baguette, sliced roast pork, ham, mayo, mustard, pickles, tomato, avocado, swiss cheese"
    },
    {
        item: "Chicken Pesto",
        ingredients: "sourdough bread, grilled chicken, pesto sauce, tomato, lettuce, provolone cheese"
    },
    {
        item: "California Chicken Club",
        ingredients: "sourdough bread, grilled chicken, bacon, mayo, mustard, lettuce, tomato, avocado, onions, swiss cheese"
    },
    {
        item: "Sloppy BBQ Brisket & Sausage",
        ingredients: "baguette, beef brisket, sausage, barbecue sauce, chipotle sauce, coleslaw, crispy fries"
    },
    {
        item: "Meatball Sandwich",
        ingredients: "meatballs, marinara sauce, provolone cheese"
    },
    {
        item: "BLT Avocado",
        ingredients: "bacon, mayo, lettuce, tomato, avocado"
    },
    {
        item: "Pastrami & Coleslaw",
        ingredients: "baguette, pastrami, thousand island dressing, coleslaw, swiss cheese"
    },
    {
        item: "Philly Cheesesteak",
        ingredients: "baguette, steak, mayo, grilled onions, bell peppers, provolone cheese"
    },
    {
        item: "Reuben",
        ingredients: "pastrami, russian dressing, sauerkraut, swiss cheese"
    },
    {
        item: "Pastrami on Rye",
        ingredients: "pastrami, mustard, pickles, swiss cheese"
    },
    {
        item: "French Dip Sandwich",
        ingredients: "roast beef, garlic aoili, provolone cheese"
    },
    {
        item: "Cheeseburger & Fries",
    },
    {
        item: "Bacon Western Cheeseburger & Fries",
    },
    {
        item: "Melts (Tuna, Turkey, or Patty)",
    },
]

export default hotSandwiches